import { rem } from 'polished';
import styled from 'styled-components';
import { IColors } from '../../interfaces/Conference';
import { breakpoints } from '../../styles/theme';

export const Wrapper = styled.div`
    padding: ${rem(40)} 0 ${rem(15)} 0;
`;

export const Title = styled.span<{ colors: IColors }>`
    padding-bottom: ${rem(30)};
    display: inline-block;
    font-weight: ${({ theme }) => theme.fontWeights.textBold};
    font-size: ${({ theme }) => theme.fontSizes.h4};
    position: relative;
    color: ${(props) => props.colors?.colorTitle};
`;

export const TitleSymbol = styled.span<{ colors: IColors }>`
    position: absolute;
    width: ${rem(40)};
    height: ${rem(5)};
    background: ${(props) => props.colors?.colorLine};
    left: 0;
    bottom: ${rem(15)};
`;

export const Tabs = styled.div`
    display: flex;
    border-bottom: 1px solid ${({ theme }) => theme.colors.secondaryGrey};
    margin-top: ${rem(20)};
`;

export const Tab = styled.div<{ colors: IColors }>`
    margin-right: ${rem(30)};
    color: ${(props) => props.colors?.colorLink};
    cursor: pointer;

    &.active {
        font-weight: ${({ theme }) => theme.fontWeights.textBold};
        border-bottom: 2px solid ${(props) => props.colors?.colorLink};
        padding-bottom: ${rem(10)};
    }
`;

export const Conference = styled.div`
    padding: ${rem(30)} 0;
`;

export const ConferenceLink = styled.a<{ colors: IColors }>`
    font-weight: ${({ theme }) => theme.fontWeights.textBold};
    color: ${(props) => props.colors?.colorLink};
    cursor: pointer;
    text-decoration: none;
`;

export const Record = styled.div``;

export const RecordLabel = styled.span`
    font-weight: ${({ theme }) => theme.fontWeights.textBold};
    display: block;
    padding-bottom: ${rem(10)};
`;

export const Source = styled.p`
    color: ${({ theme }) => theme.colors.grey};
    font-size: ${({ theme }) => theme.fontSizes.textBase};
    padding: ${rem(10)} 0;
`;

export const Gallery = styled.div``;

export const GalleryLabel = styled.span`
    font-weight: ${({ theme }) => theme.fontWeights.textBold};
    display: block;
    padding-bottom: ${rem(5)};
`;

export const GalleryDescription = styled.span``;

export const GalleryImage = styled.img`
    width: 95% !important;
    cursor: pointer;
`;

export const CarouselWrapper = styled.div`
    padding: ${rem(20)} 0;

    @media (min-width: ${breakpoints.md}px) {
        max-width: ${rem(805)};
    }
`;

export const Content = styled.div``;

export const RecordContent = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 450px;
    padding: ${rem(10)} ${rem(10)};
    align-items: center;
    @media (max-width: ${breakpoints.sm}px) {
        width: 100%;
    }
`;

export const EmbedContent = styled.div`
    position: relative;
    display: block;
    width: 100%;
    height: 100%;
    padding: 0;
    overflow: hidden;
`;

export const Embed = styled.iframe`
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 100%;
    border: 0;
`;
